// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YoC4","top":"styles_top__2tX_3"};